import { ClassData } from "../../../common/dtos/classes.type";
import RYBConnectClasses from "../../../common/services/classes.service";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import {
  RYB_CLASSES_DATA,
  URL_PARAMETERS,
} from "../../../common/utils/const.util";
import {
  getAllParamsFromURL,
  modifyUrlParameter,
  setUrlParameter,
} from "../../../common/utils/url.util";
import { processResult } from "../../finder/services/result.service";
import { DOMObserverService } from "./dom-observer.service";

export class ClassesService {
  private static isExecuted = false;
  public static async addEventListener() {
    DOMObserverService.watchForClass(
      ".box.classes",
      "show",
      async () => await this.onStepOpen()
    );

    if ($("#available-categories .loader-container")) {
      await this.onStepOpen();
    }

    $("#available-categories").on("click", ".category-card", function () {
      const categoryId = $(this).data("category-id");
      if (categoryId) {
        setUrlParameter(URL_PARAMETERS.CATEGORY, categoryId.toString());
        setUrlParameter(URL_PARAMETERS.STEP, "3");
      }
    });
  }

  public static setResultsNumber(uniqueCategories: any[]) {
    let results = 0;
    const visibleClasses = RYB_CLASSES_DATA.classes.filter(
      (item) => item.status !== "Hide"
    );
    for (const category of uniqueCategories) {
      if (
        visibleClasses.some((item) => item.name === category[DEFAULT_CATEGORY])
      ) {
        results++;
      }
    }
    $(".box.classes .classes-number").text(`${results}`);
  }

  public static async onStepOpen() {
    const classes = new RYBConnectClasses();
    const data = await classes.getFilteredDataByURLParams();
    if (data) {
      $("#available-categories").empty();
      $(".box.classes .controls button").removeAttr("disabled");
      this.setCategoryElements();
      this.setClassElementsWithCategories(data);
    }

    $(".box.classes .controls button").on("click", () => {
      this.onNextStep();
    });
  }

  public static setClassElementsWithCategories(data: ClassData[]) {
    const uniqueCategories = Array.from(
      new Set(data.map((item) => item[DEFAULT_CATEGORY]))
    ).map((uniqueValue) => {
      return data?.find((item) => item[DEFAULT_CATEGORY] === uniqueValue);
    });
    this.setResultsNumber(uniqueCategories || []);
    const availableCategories = uniqueCategories.map((location) => ({
      label: location?.name,
      value: location?.[DEFAULT_CATEGORY],
    }));
    const isSingleCategory = availableCategories.length === 1;

    const template = document.getElementById(
      "category-card-template"
    )?.innerHTML;
    const sortedCategories = availableCategories
      .map((category) => {
        const currentClassData = RYB_CLASSES_DATA.classes?.find(
          (classData) => classData.name === category.value
        );
        return {
          ...category,
          orderNumber: parseInt(currentClassData?.order_number || "0", 10),
          currentClassData,
        };
      })
      .filter((item) => !Boolean(item.currentClassData?.status === "Hide"))
      .sort((a, b) => a.orderNumber - b.orderNumber);
    sortedCategories.forEach((category) => {
      const constCurrentClassData = RYB_CLASSES_DATA.classes?.find(
        (category2) => category2.name === category.value
      );

      if (!Boolean(constCurrentClassData?.status === "Hide")) {
        let imageTag = "";
        if (constCurrentClassData?.url) {
          imageTag = `<img src="${constCurrentClassData.url}" alt="Location" />`;
        }

        const cardHtml = template
          ?.replace(
            "{{categoryValue}}",
            constCurrentClassData?.display_name || (category.value as any)
          )
          .replace(
            "{{categoryLabel}}",
            constCurrentClassData?.description || (category.label as any)
          )
          .replace("{{imageTag}}", imageTag)
          .replace(
            "{{inviteOnlyMessage}}",
            constCurrentClassData?.invite_only_invitation_message || ""
          );
        const $card = $(cardHtml || "");
        if (constCurrentClassData?.status === "Invite-only") {
          $card.find(".invite-only-box").removeClass("hide");
        }

        if (isSingleCategory) {
          $card.addClass("active");
          const url = new URL(window.location.href);
          url.searchParams.set(URL_PARAMETERS.CATEGORY, category.value as any);
          history.pushState({}, "", url);
        }

        $card.click(function () {
          $(this).toggleClass("active");
          modifyUrlParameter(
            $(this).hasClass("active"),
            category?.value || "",
            URL_PARAMETERS.CATEGORY
          );
        });
        const targetSelector = constCurrentClassData?.category_id
          ? `#available-categories div[data-target="${constCurrentClassData.category_id}"] .results`
          : '#available-categories div[data-target="other"] .results';

        $(targetSelector).append($card);
      }
    });
  }

  public static setCategoryElements() {
    if (
      !ryb_connect_classes_data.categories ||
      !ryb_connect_classes_data.categories.length
    ) {
      return;
    }
    const categories = [...ryb_connect_classes_data.categories].sort(
      (a, b) => parseInt(a.order_number) - parseInt(b.order_number)
    );

    $.each(categories, function (_index, category) {
      $("<div>", {
        "data-target": category.id,
        "data-name": category.name,
        "data-order": category.order_number,
      })
        .append(
          $("<h3>", {
            text: category.name,
          })
        )
        .append("<div class='results'>")
        .appendTo("#available-categories");
    });

    $("<div>", {
      "data-target": "other",
      "data-name": "Other",
      "data-order": "999",
    })
      .append(
        $("<h3>", {
          text: "Other",
        })
      )
      .append("<div class='results'>")
      .appendTo("#available-categories");
  }

  private static async submitCRMData() {
    const allParams = getAllParamsFromURL();
    const isUser = allParams.user === 'true';
    const classesInterestedIn = allParams.category;
    const contactId = localStorage.getItem("ghlContactId");
    if (!contactId || isUser) {
      return;
    }

    await $.ajax({
      url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        request_url: `https://services.leadconnectorhq.com/contacts/${contactId}`,
        include_location_id: false,
        method: "PUT",
        body: {
          customFields: [
            {
              key: "classes_interested_in",
              field_value: classesInterestedIn,
            },
            {
              key: "last_funnel_url",
              field_value: new URL(window.location.href),
            },
            {
              key: "step_1",
              field_value: "Step 3 | Class selection",
            },
          ],
        }
      })
    });
  }

  private static onNextStep() {
    this.submitCRMData();
    $(".box.show").removeClass("show");
    $(".wizard-stage").removeClass("active");
    $("#ryb-openings-result").addClass("show");
    setUrlParameter(URL_PARAMETERS.STEP, "3");
    // handles finder display
    if (this.isExecuted === false) {
      processResult();
      this.isExecuted = true;
      $(".step-view.result").show();
    }
  }
}
